import { useSelector } from "@legendapp/state/react";
export const useSubscribe = (observableObject, trackingType) => {
    return useSelector(() => observableObject?.get(trackingType));
};
